<template>
 <el-card class="box-card detail-screen mb-35">
    <el-row class="title">
      <el-col :span="24">{{ contact.name_category }}</el-col>
    </el-row>
    <el-row>
      <div class="full-width">
        <div class="el-col float-left mr-25">
          <el-avatar :size="100" :src="contact.contacter_avatar_url"/>
        </div>
        <div class="el-col text-left float-left">
          <el-row class="row-data">
            <el-col :span="24">{{ $t('contacts.id') }}: {{ contact.p_id }}</el-col>
            <el-col :span="24">{{ getContactName() }} 様 <span v-if="contact.contacter_id">({{ contact.contacter_id }})</span></el-col>
            <el-col :span="24">{{ $dayjs(contact.created_at).format('YY/MM/DD HH:mm') }}</el-col>
          </el-row>
        </div>
        <div class="el-col text-right status-label">
          <span v-html="statusLabel"></span>
        </div>
      </div>
      <p v-html="contact.content_formated" class="full-width row-data break-word mt-0 content"></p>
    </el-row>
    <el-row v-if="this.contact.type == contactTypes.reply_from_admin">
      <el-col :span="24" class="text-left mt-20">
        <el-button @click="back" class="btn btn-back">{{ $t('contacts.back') }}</el-button>
      </el-col>
    </el-row>
  </el-card>
  <el-card class="box-card mb-50 pb-30 box-contact-only-staff" v-if="this.contact.type != contactTypes.reply_from_admin">
    <list-contact-message
      :contact="contact"
      :urls="urls"
      :site="site"
      @status-label="setStatusLabel"
    >
    </list-contact-message>
  </el-card>
</template>

<script>
  import { STATUS_CONTACT } from '../../constants'
  import { convertStatusLabel, convertStatusLabelPartner } from '../../common'

  export default {
    props: {
      contact: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      site: { type: Number, required: false },
    },
    data() {
      return {
        contactTypes: STATUS_CONTACT,
        statusLabel: '',
      }
    },
    methods: {
      back() {
        window.location.href = this.urls.index;
      },

      setStatusLabel(status, statusLabel) {
        this.statusLabel = (this.site === this.$siteType.site_partner ? convertStatusLabelPartner(status, statusLabel) : convertStatusLabel(status, statusLabel));
      },

      getContactName() {
        return this.contact.contacter_name.trim() ? this.contact.contacter_name : this.contact.user.nickname
      },
    },
  }
</script>

<style lang="scss" scoped>
  .detail-screen {
    .mr-25 {
      margin-right: 25px;
    }
    .row-data {
      border-bottom: none;
      border-top: none;
      padding: 0;
      margin: 0;
    }

    .content {
      line-height: normal;
      padding-top: 8px;
    }

    .title {
      border-bottom: 1px solid #ebeef5;
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
      margin-bottom: 20px;
      font-weight: 700;
    }

    .status-label {
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
    }
  }
</style>
